import { createSlice } from '@reduxjs/toolkit';
import { superAdminAct } from '../actions';
import { SuperAdminState } from '../types';

const initialState: SuperAdminState = {
  billingData: {
    loading: false,
    list: [],
    totalDocs: 0,
  },
  reportData: {
    loading: false,
    fpsList: [],
    smartPensionList: [],
  },
  bannerData: {
    loading: false,
    list: [],
  },
  aiChatData: {
    loading: false,
    list: [],
    totalDocs: 0,
    stats: [],
  },
  payslipVerifierData: {
    loading: false,
    list: [],
    totalDocs: 0,
    stats: null,
  },
};

const superAdminSlice = createSlice({
  name: 'superAdminSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Billing
    builder.addCase(superAdminAct.getBillingAccountCodes.pending, (state) => {
      state.billingData.loading = true;
    });
    builder.addCase(
      superAdminAct.getBillingAccountCodes.fulfilled,
      (state, { payload = {} }) => {
        state.billingData.loading = false;
        state.billingData.list = payload?.data?.list || payload?.data?.data || [];
        state.billingData.totalDocs = payload?.data?.totalDocs || 0;
      },
    );
    builder.addCase(
      superAdminAct.getBillingAccountCodes.rejected,
      (state) => {
        state.billingData.loading = false;
      },
    );

    // Internal Report - FPS
    builder.addCase(superAdminAct.getInternalReport.pending, (state) => {
      state.reportData.loading = true;
    });
    builder.addCase(
      superAdminAct.getInternalReport.fulfilled,
      (state, { payload = {} }) => {
        state.reportData.loading = false;
        state.reportData.fpsList = payload?.data?.data || payload?.data || [];
      },
    );
    builder.addCase(superAdminAct.getInternalReport.rejected, (state) => {
      state.reportData.loading = false;
    });

    // Internal Report - Smart Pension
    builder.addCase(superAdminAct.getSmartPensionReport.pending, (state) => {
      state.reportData.loading = true;
    });
    builder.addCase(
      superAdminAct.getSmartPensionReport.fulfilled,
      (state, { payload = {} }) => {
        state.reportData.loading = false;
        state.reportData.smartPensionList =
          payload?.data?.data || payload?.data || [];
      },
    );
    builder.addCase(
      superAdminAct.getSmartPensionReport.rejected,
      (state) => {
        state.reportData.loading = false;
      },
    );

    // Banner
    builder.addCase(superAdminAct.getBannerList.pending, (state) => {
      state.bannerData.loading = true;
    });
    builder.addCase(
      superAdminAct.getBannerList.fulfilled,
      (state, { payload = {} }) => {
        state.bannerData.loading = false;
        state.bannerData.list = payload?.data?.data || payload?.data || [];
      },
    );
    builder.addCase(superAdminAct.getBannerList.rejected, (state) => {
      state.bannerData.loading = false;
    });

    // AI Chats - session list
    builder.addCase(superAdminAct.getAiChatSessions.pending, (state) => {
      state.aiChatData.loading = true;
    });
    builder.addCase(
      superAdminAct.getAiChatSessions.fulfilled,
      (state, { payload = {} }) => {
        state.aiChatData.loading = false;
        state.aiChatData.list = payload?.data?.data || [];
        state.aiChatData.totalDocs = payload?.data?.totalDocs || 0;
      },
    );
    builder.addCase(superAdminAct.getAiChatSessions.rejected, (state) => {
      state.aiChatData.loading = false;
    });

    // AI Chats - usage stats
    builder.addCase(
      superAdminAct.getAiChatStats.fulfilled,
      (state, { payload = {} }) => {
        state.aiChatData.stats = payload?.data?.data || [];
      },
    );
    builder.addCase(superAdminAct.getAiChatStats.rejected, (state) => {
      state.aiChatData.stats = [];
    });

    // Payslip Verifier - verification list
    builder.addCase(superAdminAct.getPayslipVerifications.pending, (state) => {
      state.payslipVerifierData.loading = true;
    });
    builder.addCase(
      superAdminAct.getPayslipVerifications.fulfilled,
      (state, { payload = {} }) => {
        state.payslipVerifierData.loading = false;
        state.payslipVerifierData.list = payload?.data?.data || [];
        state.payslipVerifierData.totalDocs = payload?.data?.totalDocs || 0;
      },
    );
    builder.addCase(superAdminAct.getPayslipVerifications.rejected, (state) => {
      state.payslipVerifierData.loading = false;
    });

    // Payslip Verifier - summary stats
    builder.addCase(
      superAdminAct.getPayslipVerifierStats.fulfilled,
      (state, { payload = {} }) => {
        state.payslipVerifierData.stats = payload?.data?.data || null;
      },
    );
    builder.addCase(superAdminAct.getPayslipVerifierStats.rejected, (state) => {
      state.payslipVerifierData.stats = null;
    });
  },
});

export const superAdminReducer = superAdminSlice.reducer;
export const superAdminActions = {
  ...superAdminSlice.actions,
  ...superAdminAct,
};
